<template>
  <div class="section-report-header-print">
    <!-- Logo -->
    <div class="header-logo" v-if="reportDetailModel.sopReportLogo">
      <img :src="reportDetailModel.sopReportLogo" 
           :class="{ 'logo-large': reportDetailModel.xyReportTemplateType === 3 }" 
           alt="logo">
    </div>
    
    <!-- 标题区域 -->
    <div class="header-titles">
      <div class="header-title">{{ reportDetailModel.sopReportHeaders || "" }}</div>
      <div class="header-subtitle">{{ pageSpecificSubtitle }}</div>
    </div>
    
    <!-- 用户信息 -->
    <div class="header-user-info">
      <div class="user-info-content">
        <!-- 第一行：基本信息 -->
        <div class="user-info-row full-width-row">
          <div class="user-info-item left-align">
            <span class="label">姓名：</span>
            <span class="value">{{ reportDetailModel.nameStr || '--' }}</span>
          </div>
          <div class="user-info-item">
            <span class="label">性别：</span>
            <span class="value">{{ reportDetailModel.genderStr || '--' }}</span>
          </div>
          <div class="user-info-item">
            <span class="label">年龄：</span>
            <span class="value">{{ reportDetailModel.ageStr || '--' }}</span>
          </div>
          <div class="user-info-item">
            <span class="label">身高：</span>
            <span class="value">{{ reportDetailModel.heightStr || '--' }}</span>
          </div>
          <div class="user-info-item">
            <span class="label">体重：</span>
            <span class="value">{{ reportDetailModel.weightStr || '--' }}</span>
          </div>
          <div class="user-info-item right-align">
            <span class="label">BMI：</span>
            <span class="value">{{ reportDetailModel.bmiStr || '--' }}</span>
          </div>
        </div>
        
        <!-- 第二行：设备信息 -->
        <div  class="user-info-row full-width-row">
          <div class="user-info-item left-align">
            <span class="label">病案号：</span>
            <span class="value">{{ reportDetailModel.medicalRecordNumber || '--' }}</span>
          </div>
          <div  class="user-info-item center-align">
            <span class="label">监测设备：</span>
            <span class="value">{{ getDeviceInfo() }}</span>
          </div>
          <div class="user-info-item right-align">
            <span class="label">监测部位：</span>
            <span class="value">指腹</span>
          </div>
          
          <!-- <div  class="user-info-item left-align">
            <span class="label">床号：</span>
            <span class="value">{{ reportDetailModel.bedNumber || '--' }}</span>
          </div>
          <div  class="user-info-item center-align">
            <span class="label">病例号：</span>
            <span class="value">{{ reportDetailModel.medicalRecordNumber || '--' }}</span>
          </div>
          <div  class="user-info-item right-align">
            <span class="label">主管医生：</span>
            <span class="value">{{ reportDetailModel.doctorName || '--' }}</span>
          </div> -->
        </div>
        
        <!-- 第三行：时间信息 -->
        <div class="user-info-row full-width-row time-row">
          <div class="user-info-item left-align">
            <span class="label">监测开始：</span>
            <span class="value">{{ reportDetailModel.startTimeStr || '--' }}</span>
          </div>
          <div class="user-info-item center-align">
            <span class="label">监测结束：</span>
            <span class="value">{{ reportDetailModel.endTimeStr || '--' }}</span>
          </div>
          <div class="user-info-item right-align">
            <span class="label">监测时长：</span>
            <span class="value">{{ reportDetailModel.totalTimeStr || '--' }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SectionReportHeaderPrint',
  
  props: {
    reportDetailModel: {
      type: Object,
      required: true
    },
    pageSpecificSubtitle: {
      type: String,
      default: ''
    }
  },

  computed: {
    isShowUserInfoRow3() {
      return (
        this.reportDetailModel.xyReportTemplateType ==
        SPO2_REPORT_TEMPLATE.广东医科大学附属第二医院
      );
    },

    isShowCaseNumber() {
      return (
        this.reportDetailModel.xyReportTemplateType ==
        SPO2_REPORT_TEMPLATE.河南省儿童医院耳鼻喉科
      );
    },
  },

  methods: {
    formatTimeRange() {
      if (this.reportDetailModel.startTimeStr && this.reportDetailModel.endTimeStr) {
        return `${this.reportDetailModel.startTimeStr} ~ ${this.reportDetailModel.endTimeStr}`;
      }
      return this.reportDetailModel.startTimeStr || '--';
    },
    getDeviceInfo() {
     
      const hasValidDeviceNumber = this.reportDetailModel.deviceNumber ? this.reportDetailModel.deviceNumber : '-';
      
      return this.reportDetailModel.sn + ('(' + hasValidDeviceNumber + ')');
    }
  }
};
</script>

<style lang="scss" scoped>
.section-report-header-print {
  width: 100%;
  background: white;
  padding: 0;
  margin: 0;
  
  // Logo区域
  .header-logo {
    position: absolute;
    top: 10px;
    left: 20px;
    
    img {
      height: 66px;
      width: 66px;
      border: 1px solid #ddd;
      
      &.logo-large {
        height: 166px;
        width: 66px;
      }
    }
  }
  
  // 标题区域
  .header-titles {
    text-align: center;
    margin-bottom: 20px;
    padding-top: 10px;
    
    .header-title {
      font-size: 20px;
      font-weight: bold;
      color: black;
      line-height: 1.3;
      margin-bottom: 5px;
    }
    
    .header-subtitle {
      font-size: 18px;
      font-weight: bold;
      color: black;
      line-height: 1.3;
    }
  }

  // 用户信息
  .header-user-info {
    // 设置与下面内容对齐的左右边距
    padding: 0 80px 0 75px;
    
    .user-info-content {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }

    .user-info-row {
      display: flex;
      align-items: center;
      min-height: 22px;
      
      // 普通行 - 左对齐，自然间距
      &:not(.full-width-row) {
        justify-content: flex-start;
        gap: 30px;
      }
      
      // 全宽度行 - 延伸到两边
      &.full-width-row {
        justify-content: space-between;
        width: 100%;
        
        .user-info-item {
          flex: 1;
          
          // 左对齐
          &.left-align {
            justify-content: flex-start;
          }
          
          // 居中对齐
          &.center-align {
            justify-content: center;
          }
          
          // 右对齐
          &.right-align {
            justify-content: flex-end;
          }
        }
      }
      
      // 时间行特殊处理
      &.time-row {
        border-bottom: 1px solid #000;
        padding-bottom: 10px;
        margin-bottom: 15px;
      }
    }

    .user-info-item {
      display: flex;
      align-items: center;
      
      .label {
        font-weight: normal;
        color: #000;
        white-space: nowrap;
        font-size: 14px;
        margin-right: 2px;
      }
      
      .value {
        color: #000;
        font-size: 14px;
        font-weight: normal;
      }
    }
  }
}

// 确保打印时样式正确
@media print {
  .section-report-header-print {
    .header-logo {
      img {
        border: 1px solid #ddd !important;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
        width: 66px !important;
        height: 66px !important;
        
        &.logo-large {
          width: 166px !important;
          height: 66px !important;
        }
      }
    }
    
    .header-titles {
      .header-title {
        font-size: 20px !important;
        color: black !important;
        font-weight: bold !important;
      }
      
      .header-subtitle {
        font-size: 18px !important;
        color: black !important;
        font-weight: bold !important;
      }
    }
    
    .header-user-info {
      // 确保打印时对齐
      // padding: 0 20px 0 20px !important;
      padding: 0 20px 0 20px !important;
      .user-info-row {
        &.time-row {
          border-bottom: 1px solid #000 !important;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
        
        &.full-width-row {
          justify-content: space-between !important;
          
          .user-info-item {
            flex: 1 !important;
            
            &.left-align {
              justify-content: flex-start !important;
            }
            
            &.center-align {
              justify-content: center !important;
            }
            
            &.right-align {
              justify-content: flex-end !important;
            }
          }
        }
      }

      .user-info-item {
        .label, .value {
          font-size: 14px !important;
          color: #000 !important;
        }
      }
    }
  }
}
</style>